import React from 'react';
import { Button } from 'react-bootstrap';
import { FaFilePdf} from 'react-icons/fa';

/**
 * PDF作成ボタンコンポーネント用のPropsです。
 * @interface CreatePdfButtonProps
 */
interface CreatePdfButtonProps {

  /**
   * ボタンのラベル名
   * @type {string}
   * @memberof CreatePdfButtonProps
   */
  buttonLabel: string;

  /**
   * 非活性フラグ
   * @type {string}
   * @memberof CreatePdfButtonProps
   */
  isDisabled: boolean;

  /**
   * ボタンクリック時の動作を設定する関数
   * @memberof CreatePdfButtonProps
   */
  onClick: () => void;
}

/**
 * PDF作成ボタンのコンポーネントです。
 * @param {string} props.buttonLabel - ボタンのラベル名
 * @param {boolean} props.isDisabled - 非活性フラグ
 * @param {function} props.onClick - ボタンクリック時によばれるコールバック関数
 * @returns {JSX.Element} - PDF作成ボタンのJSX要素
 */
const CreatePdfButton: React.FC<CreatePdfButtonProps> = ({ buttonLabel, isDisabled, onClick }) => {
  return (
    <Button
      variant="primary"
      className="text-white"
      disabled={isDisabled}
      onClick={onClick}
    >
      <FaFilePdf />
      <span className="ms-2">{buttonLabel}</span>
    </Button>
  );
}

export default CreatePdfButton;